import renterIcon from '@src/assets/svg/renterIcon';
import agentIcon from '@src/assets/svg/agentIcon';
import ownerIcon from '@src/assets/svg/ownerIcon';

const ZEME_USERS_ROLE = {
  RENTER: 'renter',
  AGENT: 'agent',
  LANDLORD: 'landlord',
};

const REGEX = {
  onlyDigit: /^\d+$/,
};

/** Match media query for desktop viewport (Tailwind sm breakpoint). Use with window.matchMedia(DESKTOP_MEDIA_QUERY). */
const DESKTOP_MEDIA_QUERY = '(min-width: 640px)';

const USERS_ROLE_WITH_DETAIL = {
  [ZEME_USERS_ROLE.RENTER]: {
    label: `${ZEME_USERS_ROLE.RENTER.charAt(
      0
    ).toUpperCase()}${ZEME_USERS_ROLE.RENTER.substring(1)}`,
    value: ZEME_USERS_ROLE.RENTER,
    subLabel: '(Or Guarantor)',
    image: renterIcon,
    isSelected: false,
  },
  [ZEME_USERS_ROLE.AGENT]: {
    label: `${ZEME_USERS_ROLE.AGENT.charAt(
      0
    ).toUpperCase()}${ZEME_USERS_ROLE.AGENT.substring(1)}`,
    image: agentIcon,
    subLabel: '',
    value: ZEME_USERS_ROLE.AGENT,
    isSelected: false,
  },
  [ZEME_USERS_ROLE.LANDLORD]: {
    label: `${ZEME_USERS_ROLE.LANDLORD.charAt(
      0
    ).toUpperCase()}${ZEME_USERS_ROLE.LANDLORD.substring(1)}`,
    value: ZEME_USERS_ROLE.LANDLORD,
    subLabel: '(Property Manager)',
    image: ownerIcon,
    isSelected: false,
  },
};
const DATE_FORMAT = 'MM/dd/yyyy';

const PLAN_FREQUENCY = { monthly: 'MONTH', yearly: 'YEARLY' }; // plan frequencies
const PLAN_TYPES = {
  perUnit: 'PER_UNIT',
  standard: 'STANDARD',
  custom: 'CUSTOM',
};

const SSO_TYPES = {
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE',
};

/* eslint-disable no-unused-vars */
export enum CANCEL_SUBSCRIPTION_ENUM {
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  ANOTHER_SOFTWARE = 'ANOTHER_SOFTWARE',
  BUSINESS_CLOSING = 'BUSINESS_CLOSING',
  NOT_ENOUGH_SUPPORT = 'NOT_ENOUGH_SUPPORT',
  OTHER_REASON = 'OTHER_REASON',
}

export enum SUBSCRIPTION_STATUS_ENUM {
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

const CANCEL_SUBSCRIPTION_REASONS = [
  {
    label: 'Too Expensive',
    value: CANCEL_SUBSCRIPTION_ENUM.TOO_EXPENSIVE,
  },
  {
    label: 'Another Software',
    value: CANCEL_SUBSCRIPTION_ENUM.ANOTHER_SOFTWARE,
  },
  {
    label: 'Business Closing',
    value: CANCEL_SUBSCRIPTION_ENUM.BUSINESS_CLOSING,
  },
  {
    label: 'Not Enough Support',
    value: CANCEL_SUBSCRIPTION_ENUM.NOT_ENOUGH_SUPPORT,
  },
  {
    label: 'Other Reason',
    value: CANCEL_SUBSCRIPTION_ENUM.OTHER_REASON,
  },
];

export enum ZEME_PAYMENT_METHODS {
  GOOGLE_PAY = 'GOOGLE_PAY',
  APPLE_PAY = 'APPLE_PAY',
  CARD_PAYMENT = 'TOKEN',
}

const EDIT_PROFILE_FIELD_KEYS = {
  NAME: 'name',
  COMPANY_NAME: 'companyName',
  EMAIL: 'email',
  LICENSE_NUMBER: 'licenseNumber',
  COMPANY_ADDRESS: 'companyAddress',
  PHONE_NUMBER: 'phoneNumber',
};

const EDIT_PROFILE_FIELDS = [
  {
    label: 'Legal Name',
    key: EDIT_PROFILE_FIELD_KEYS.NAME,
    isAgentOrLandlord: false,
  },
  {
    label: 'Company Name',
    key: EDIT_PROFILE_FIELD_KEYS.COMPANY_NAME,
    isAgentOrLandlord: true,
  },
  {
    label: 'Email Address',
    key: EDIT_PROFILE_FIELD_KEYS.EMAIL,
    isAgentOrLandlord: false,
  },
  {
    label: 'License Number',
    key: EDIT_PROFILE_FIELD_KEYS.LICENSE_NUMBER,
    isAgentOrLandlord: true,
    isAgentOnly: true,
  },
  {
    label: 'Company Address',
    key: EDIT_PROFILE_FIELD_KEYS.COMPANY_ADDRESS,
    isAgentOrLandlord: true,
  },
  {
    label: 'Phone Number',
    key: EDIT_PROFILE_FIELD_KEYS.PHONE_NUMBER,
    isAgentOrLandlord: false,
  },
];

const SUBSCRIPTION_TABS = {
  UPCOMING: 'upcoming',
  INVOICES: 'invoices',
};

const SUBSCRIPTION_TAB_CONFIG = [
  {
    value: SUBSCRIPTION_TABS.UPCOMING,
    label: 'Upcoming',
  },
  {
    value: SUBSCRIPTION_TABS.INVOICES,
    label: 'Invoices',
  },
];

export const ZEME_USERS_TYPE = {
  AGENT: 'Agents',
  RENTER: 'Renters',
  LANDLORD: 'Landlords',
};

const LOGIN_STEPS = {
  PHONE: 'phone',
  SMS: 'sms',
  SUCCESS: 'success',
  EMAIL: 'email',
  EMAIL_VERIFICATION: 'emailVerification',
  USER_DETAILS: 'userDetails',
  WORK_DETAILS: 'workDetails',
  APPLE_ERROR: 'appleError',
  UPDATE_EMAIL: 'updateEmail',
  UPDATE_PHONE: 'updatePhone',
} as const;

const REGISTER_STEPS = {
  USER_TYPE: 'userType',
  PHONE: 'phone',
  OTP: 'otp',
  USER_DETAILS: 'userDetails',
  WORK_DETAILS: 'workDetails',
  EMAIL_VERIFICATION: 'emailVerification',
  EMAIL_CONFIRM: 'emailConfirm',
  UPDATE_EMAIL: 'updateEmail',
  UPDATE_PHONE: 'updatePhone',
} as const;

const SUBSCRIBE_STEPS = {
  SELECT_PLAN: 'select-plan',
  VERIFICATION: 'verification',
} as const;

const OTP_VARIANTS = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const;

const FORM_FIELD_NAMES = {
  CODE: 'code',
  PHONE: 'phone',
  EMAIL: 'email',
  PASSWORD: 'password',
} as const;

const SUBSCRIPTION_LABELS = {
  FREE: 'Free',
  MONTH: 'month',
  RECOMMEND: 'Recommend',
  INCLUDES: 'Includes',
  PURCHASE_PRO: 'Purchase Pro',
  CONTINUE_FREE: 'Continue Free',
  EXPLORE: 'Explore',
} as const;

const MEMBER_LABELS = {
  PRO_MEMBER: 'Zeme Pro Member',
  MEMBER: 'Zeme Member',
} as const;

const SUPPORT_EMAIL = 'hey@zeme.io';

const DEFAULT_USER_NAME = 'Trung Vo';

const COPYRIGHT_TEXT = 'Zeme ©2026';

export {
  ZEME_USERS_ROLE,
  REGEX,
  DESKTOP_MEDIA_QUERY,
  USERS_ROLE_WITH_DETAIL,
  DATE_FORMAT,
  PLAN_FREQUENCY,
  PLAN_TYPES,
  CANCEL_SUBSCRIPTION_REASONS,
  SSO_TYPES,
  EDIT_PROFILE_FIELDS,
  EDIT_PROFILE_FIELD_KEYS,
  LOGIN_STEPS,
  REGISTER_STEPS,
  SUBSCRIBE_STEPS,
  OTP_VARIANTS,
  FORM_FIELD_NAMES,
  SUBSCRIPTION_LABELS,
  MEMBER_LABELS,
  SUPPORT_EMAIL,
  DEFAULT_USER_NAME,
  COPYRIGHT_TEXT,
  PAYMENT_LABELS,
  SUBSCRIPTION_TABS,
  SUBSCRIPTION_TAB_CONFIG,
};

const PAYMENT_LABELS = {
  APPLICATION_FEE: 'Application Fee',
  SUBSCRIPTION_FEE: 'Subscription Fee',
} as const;
